/**
 * The base URL for API requests, configured via VITE_API_URL.
 * This should be the full URL to the API (e.g., "http://localhost:3001").
 */
export const apiBaseUrl = import.meta.env.VITE_API_URL ?? "";

/**
 * Build a URL to the API using the configured VITE_API_URL.
 */
export const buildApiUrl = (path = ""): string => {
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${apiBaseUrl}${normalized}`;
};

export const createDonationCheckoutUrl = buildApiUrl(
  "/products/donation-checkout"
);

export const newsletterSubscribeUrl = buildApiUrl("/newsletter/subscribe");

/** Independent Rust endpoint; can be hosted by any netcode service operator. */
const netcodeBaseUrl = (import.meta.env.VITE_NETCODE_URL ?? "").replace(/\/$/, "");
export const netcodeEndpoints = {
  serverUrl: netcodeBaseUrl,
};
